export default "__VITE_ASSET__CF1H0HjO__"